import { AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { FooterModule } from '@usitsdasdesign/dds-ng/footer';
import { Footer } from './footerModel';
import { FooterService } from './footer.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { MediaService } from '../services/media.service';
import { MediaHandlerService } from '../services/media-handler.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [FooterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  currentYear: number;
  footer: Footer;
  safeFooterDataHtml: SafeHtml;
  private mediaObserver: MutationObserver;
  @Input() footerData: string;

  constructor(private footerService: FooterService,
    private sanitizer: DomSanitizer,
    private elRef: ElementRef,
    private mediaHandlerService: MediaHandlerService) {
  }
  ngOnInit(): void {
    if (this.footerData) {
      this.processFooterData(this.footerData);
    }
  }

  ngOnChanges(): void {
    if (this.footerData) {
      this.processFooterData(this.footerData); 
      setTimeout(() => {
        this.processMedia();
        this.observeDynamicContent();
      }, 0);      
    }
  }

  private processFooterData(footerData: string): void {
    this.currentYear = new Date().getFullYear();
    const updatedFooterData = footerData.replace("{{currentYear}}", this.currentYear.toString());
    this.safeFooterDataHtml = this.sanitizer.bypassSecurityTrustHtml(updatedFooterData);
  }

  private getFooterData() {
    this.footerService.getData().subscribe(response => {
      const footerData = response?.[0].htmlContent;
      this.currentYear = new Date().getFullYear();
      const updatedFooterData = footerData?.replace("{{currentYear}}", this.currentYear.toString());
      this.safeFooterDataHtml = this.sanitizer.bypassSecurityTrustHtml(updatedFooterData);
      
    })
  }

  processMedia(): void {
    const element = this.elRef.nativeElement;
    this.mediaHandlerService.processMedia(element, 'img');
  }
  observeDynamicContent(): void {
    const element = this.elRef.nativeElement;
    this.mediaObserver = new MutationObserver(() => {
      this.mediaHandlerService.processMedia(element, 'img');
    });
    this.mediaObserver.observe(element, { childList: true, subtree: true, });
  }

  ngOnDestroy(): void {
    if (this.mediaObserver) {
      this.mediaObserver.disconnect();
    }
  }
}
